export default __webpack_public_path__ + "static/graph-2c49724d9c271854631ae8388c997039.svg";